module.exports = __webpack_public_path__ + "img/24.3b00a9a4.webp";